'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:DirectorCtrl
 * @description
 * # DirectorCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
    .controller('DirectorCtrl',
        ['$scope', '$routeParams', '$location', '$http', 'Session', '$uibModal', 'ReportService', 'ApiUrl', '$timeout',
        function($scope, $routeParams, $location, $http, Session, $uibModal, ReportService, ApiUrl, $timeout) {

            $scope.showActiveEvents = true;
            $scope.showInactiveEvents = false;
            $scope.haveInactiveEvents = false;

            var sessionObject = Session.getSessionObject();
            if (!sessionObject.isAuthenticated) {
                $location.url('/');
                return;
            }
            if (!sessionObject.isDirector &&
                !sessionObject.isAlternate &&
                !sessionObject.isAdmin &&
                !sessionObject.isProjectAdmin) {
                $location.url('/');
                return;
            }
            if (sessionObject.isDirector) {
                //Actual director role
                $scope.IsDirector = true;
            } else {
                //Alternate role
                $scope.IsDirector = false;
            }

            var _grantapiUrl = ApiUrl.url('/Grant/');
            var _surveyapiUrl = ApiUrl.url('/Survey/');

            $scope.saveMessage = '';
            $scope.saving = false;
            $scope.saveID = null;
            $scope.today = new Date();

            $http.get(_grantapiUrl + 'GrantsAndSurveys')
            .then(function (response) {
                // The dates need to be turned into JS date objects in order to work properly
                // with the date input field
                for (var i = 0; i < response.data.length; i++) {
                    var grant = response.data[i];
                    for (var j = 0; j < grant.Surveys.length; j++) {
                        var survey = grant.Surveys[j];
                        if (survey.FirstReminderDate !== null) {
                            survey.FirstReminderDate = new Date(survey.FirstReminderDate);
                        }
                        if (survey.SecondReminderDate !== null) {
                            survey.SecondReminderDate = new Date(survey.SecondReminderDate);
                        }
                    }
                }
                $scope.grants = response.data;

                    for (let i = 0; i < $scope.grants.length; i++) {

                        // If this event has surveys, but they're all closed
                        if ($scope.grants[i].HaveClosedSurveys && !$scope.grants[i].HaveOpenSurveys) {
                            // The event is inactive
                            $scope.haveInactiveEvents = true;
                            break;
                        }
                    }

                },
                    function (err) {
                        $location.path('error');
                    });

            $scope.sendReminderEmailPopup = function (grantID, surveyID) {
                $scope.reminderData = {};
                var surveyName;
                for (var i = 0; i < $scope.grants.length; i++) {
                    var grant = $scope.grants[i];
                    if (grant.GrantID === grantID) {
                        for (var j = 0; j < grant.Surveys.length; j++) {
                            var survey = grant.Surveys[j];
                            if (survey.SurveyID === surveyID) {
                                $scope.reminderData.grantID = grant.GrantID;
                                $scope.reminderData.surveyID = survey.SurveyID;
                                $scope.reminderData.surveyName = survey.Name;
                                $scope.reminderData.lastReminded = survey.LastReminderSent;

                                $scope.reminderData
                                    .formattedLastReminded = survey.LastReminderSent === null ? null : survey.LastReminderSent + 'Z';
                                
                                //format the date so it'll display appropriately
                                break;
                            }
                        }
                        break;
                    }
                }

                if ($scope.reminderData.surveyID) {
                    $http.get(_surveyapiUrl + "UsersForReminderEmail/" + $scope.reminderData.surveyID)
                        .then(function (response) {
                            $scope.reminderData.notCompleted = response.data;
                            $('#reminderPopup').modal('show');
                        });


                }

            };

            $scope.sendReminderEmail = function (grantID, surveyID, surveyName) {
                var data = {
                    SurveyID: surveyID,
                    SurveyName: surveyName
                };

                $http.post(_surveyapiUrl + 'SendReminderEmail', data)
                    .then(function (response) {
                        if (response.data) {
                            $scope.reminderData.sentReminder = true;

                            $scope.reminderData.remindersSent = response.data.NumberSent;
                            $scope.reminderData.remindersFailed = response.data.NumberFailed;

                            for (var i = 0; i < $scope.grants.length; i++) {
                                var grant = $scope.grants[i];
                                if (grant.GrantID === grantID) {
                                    for (var j = 0; j < grant.Surveys.length; j++) {
                                        var survey = grant.Surveys[j];
                                        if (survey.SurveyID === surveyID) {
                                            survey.LastReminderSent = response.data.LastReminderSent;
                                            $scope.reminderData.lastReminded = response.data.LastReminderSent;
                                            $scope.reminderData
                                                .formattedLastReminded = new Date(response.data.LastReminderSent);
                                            //format the date so it'll display appropriately
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }


                        }
                    },
                        function (err) {
                            $location.path('error');
                        });
            };

            $scope.closeSurvey = function (survey) {
                var closeModal = $uibModal.open({
                    animation: true,
                    templateUrl: 'closeSurvey.html',
                    controller: 'closeSurveyCtrl',
                    resolve: {
                        surveyName: function () {
                            return survey.Name;
                        }
                    }
                });
                closeModal.result.then(function (accepted) {
                    var data = {
                        Integer: survey.SurveyID
                    };
                    if (accepted) {
                        $http.post(_surveyapiUrl + 'CloseSurvey', data)
                            .then(function (response) {
                                survey.IsOpen = false;
                                survey.Completed = response.data;
                            });
                    }
                });
            };

            $scope.deleteSurvey = function (survey, grantID) {
                var deleteModel = $uibModal.open({
                    animation: true,
                    templateUrl: 'deleteSurvey.html',
                    controller: 'deleteSurveyCtrl',
                    resolve: {
                        surveyName: function () {
                            return survey.Name;
                        }
                    }
                });
                deleteModel.result.then(function (accepted) {
                    var data = {
                        Integer: survey.SurveyID
                    };
                    if (accepted) {
                        $http.post(_surveyapiUrl + 'DeleteSurvey', data)
                            .then(function (response) {
                                for (var i = 0; i < $scope.grants.length; i++) {
                                    var grant = $scope.grants[i];
                                    if (grant.GrantID === grantID) {
                                        for (var j = 0; j < grant.Surveys.length; j++) {
                                            if (grant.Surveys[j].SurveyID === survey.SurveyID) {
                                                grant.Surveys.splice(j, 1);
                                            }
                                        }
                                    }
                                }
                            });
                    }
                });
            };
            $scope.downloadData = function (survey) {
                ReportService.downloadDataCsv(survey.SurveyID);
            };

            $scope.showDataSharingAgreement = function (grant, survey) {
                var closeModal = $uibModal.open({
                    animation: true,
                    templateUrl: 'dataSharingAgreement.html',
                    controller: 'dataSharingAgreementCtrl',
                });


                closeModal.result.then(function (response) {
                    if (response) {
                        if (response.radioSelection === 'agree') {
                            //need to persist the datesigned

                            response.grant = grant;
                            ReportService.saveDataSharingAgreement(response)
                                .then(function () {
                                    $scope.downloadData(survey);
                                });
                        } else if (response.radioSelection === 'doesNotApply' &&
                            response.irbNumber !== null &&
                            response.selectedInstitution !== null) {
                            //does not apply AND they picked an institution and provided an IRB number
                            response.grant = grant;
                            ReportService.saveDataSharingAgreement(response)
                                .then(function () {
                                    $scope.downloadData(survey);
                                });

                            //need to persist the irb number, institution and datesigned
                            $scope.downloadData(survey);

                        } else {
                            //they didn't agree.  we can just bail out
                        }
                    }
                });
            };
                
            // Get active events
            $scope.filterGrantsWithOpenOrNoSurveys = function (grant) {

                // If this grant/event has any open surveys, or no surveys at all
                if (grant.HaveOpenSurveys || (!grant.HaveOpenSurveys && !grant.HaveClosedSurveys)) {
                    return true;
                }

                return false;
            };

            // Get inactive events
            $scope.filterGrantsWithOnlyClosedSurveys = function (grant) {

                // If this grant has closed surveys and no open surveys
                if(!grant.HaveOpenSurveys && grant.HaveClosedSurveys){
                    return true;
                }
                return false;
            };

            $scope.saveReminderDates = function (survey) {
                $scope.saveID = survey.SurveyID;

                $scope.validateDate(survey);
                if ($scope.firstDateInvalid || $scope.secondDateInvalid || $scope.datesMatch) {
                    return;
                }

                var data = {
                    SurveyID: survey.SurveyID,
                    FirstReminderDate: survey.FirstReminderDate,
                    SecondReminderDate: survey.SecondReminderDate
                };
                $scope.saving = true;

                $http.post(_surveyapiUrl + 'SaveReminderDates', data)
                    .then(function (response) {
                        if (response.data) {
                            $scope.successMessage();
                            $scope.saving = false;
                        }
                        else {
                            $location.path('error');
                        }
                    },
                    function (err) {
                        $location.path('error');
                    });
            };

            $scope.validateDate = function (survey) {
                // Set this so error messages appear in the correct location
                $scope.saveID = survey.SurveyID;
                // Dates are null when no value and undefined with invalid value
                if (survey.FirstReminderDate === undefined) {
                    $scope.firstDateInvalid = true;
                }
                else {
                    $scope.firstDateInvalid = false;
                }
                if (survey.SecondReminderDate === undefined) {
                    $scope.secondDateInvalid = true;
                }
                else {
                    $scope.secondDateInvalid = false;
                }
                if (!$scope.firstDateInvalid && !$scope.secondDateInvalid && survey.FirstReminderDate && survey.SecondReminderDate && survey.FirstReminderDate.getTime() === survey.SecondReminderDate.getTime()) {
                    $scope.datesMatch = true;
                }
                else {
                    $scope.datesMatch = false;
                }
            };

            $scope.successMessage = function () {
                $scope.saveMessage = 'Reminder Dates(s) successfully updated';
                $timeout(function () {
                    $scope.saveMessage = '';
                }, 5000);
            };

            $scope.formattedReport = function (surveyID) {
                $location.url('report/' + surveyID);
            };

            $scope.assignSurvey = function (surveyID, grantID) {
                $location.url('assignSurvey/' + grantID + '/' + surveyID);
            };

            $scope.editSurvey = function (surveyID, grantID) {
                $location.url('customSurvey/' + grantID + '?edit=' + surveyID);
            };
        }
    ])
    .controller('userSurveryOverviewCtrl',
        [
            '$scope', '$uibModalInstance', 'surveyName', 'users', function ($scope, $uibModalInstance, surveyName, users) {
                $scope.surveyName = surveyName;
                $scope.users = users;

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        ])
    .controller('closeSurveyCtrl',
        [
            '$scope', '$uibModalInstance', 'surveyName', function ($scope, $uibModalInstance, surveyName) {
                $scope.surveyName = surveyName;

                $scope.accept = function () {
                    $uibModalInstance.close(true);
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        ])
    .controller('deleteSurveyCtrl',
        [
            '$scope', '$uibModalInstance', 'surveyName', function ($scope, $uibModalInstance, surveyName) {
                $scope.surveyName = surveyName;

                $scope.accept = function () {
                    $uibModalInstance.close(true);
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        ]);
   
